module.exports = __webpack_public_path__ + "img/10no-eight.12cb2543.jpg";